import styled from 'styled-components';

export const NavigationBarContainer = styled.div`
  width: 100%;
  height: ${({ theme }) => `calc(${theme.config.navigationHeight} + 10px)`};
  padding-bottom: 20px;
  background: #2b2b2c;
  color: #fff;
  position: fixed;
  bottom: 0;
  z-index: 3;

  p {
    font-size: 10px;
  }

  p,
  span {
    opacity: 0.5;
  }

  a:hover,
  a:active,
  a.active {
    span,
    p {
      opacity: 1;
      font-weight: 500;
    }
  }
`;
